// @ts-nocheck

import type { Module } from 'vuex'

import { CampaignRepository } from '@/legacy/repositories/campaignRepository'
import * as types from '@/legacy/store/mutation-types'
import { normalizeCampaignServerData } from '@/lib/helpers/campaign.helpers'
import type { CampaignType } from '@/types'

type CampaignStateType = {
  data: CampaignType | null
  error: object | null
  isLoading: boolean
  isFetching: boolean
  isFetched: boolean
}

export const campaign: Module<CampaignStateType, never> = {
  namespaced: true,
  state: {
    data: null,
    error: null,
    isLoading: false,
    isFetching: false,
    isFetched: true,
  },
  getters: {
    state: (state) => state,
    campaignInfo: (state) => state.data,
    isLoading: (state) => state.isLoading,
    isFetching: (state) => state.isFetching,
    isFetched: (state) => state.isFetched,
    error: (state) => state.error,
  },
  mutations: {
    [types.SET_ERROR]: (state, value) => (state.error = value),
    [types.SET_LOADING]: (state, value) => (state.isLoading = value),
    [types.SET_FETCHING]: (state, value) => (state.isFetching = value),
    [types.SET_IS_FETCHED]: (state, value) => (state.isFetched = value),
    [types.SET_DATA]: (state, value) => (state.data = value),
    [types.RESET]: (state) => {
      state.data = null
      state.error = null
      state.isLoading = false
      state.isFetching = false
      state.isFetched = false
    },
  },
  actions: {
    async getCampaign(
      { commit, rootState, state },
      { id, includes }: { id: string; includes?: string[] },
    ) {
      try {
        commit(types.SET_LOADING, true)
        if (!state.isFetched) {
          commit(types.SET_FETCHING, true)
        }
        const { data } = await CampaignRepository.fetchCampaign(id, rootState.user.token, includes)
        commit(types.SET_DATA, normalizeCampaignServerData(data))
      } catch (e) {
        commit(types.SET_ERROR, e)
        commit(types.SET_LOADING, false)
        commit(types.SET_FETCHING, false)
        commit(types.SET_IS_FETCHED, true)
      } finally {
        commit(types.SET_LOADING, false)
        commit(types.SET_FETCHING, false)
        commit(types.SET_IS_FETCHED, true)
      }
    },
    async createCampaign(
      { commit, rootState },
      { body, logoFile }: { body: never; logoFile: File },
    ) {
      try {
        commit(types.SET_LOADING, true)
        const { data } = await CampaignRepository.createCampaign(
          body,
          rootState.shop.shop.id,
          rootState.user.token,
        )
        if (logoFile) {
          await CampaignRepository.updateCampaignLogo(logoFile, data.data.id, rootState.user.token)
        }

        return data.data
      } catch (e) {
        commit(types.SET_ERROR, e)
      } finally {
        commit(types.SET_LOADING, false)
      }
    },
    async updateCampaign(
      { commit, rootState },
      { id, body, logoFile }: { body: never; id: string; logoFile: File },
    ) {
      try {
        commit(types.SET_LOADING, true)
        const { data } = await CampaignRepository.updateCampaign(body, id, rootState.user.token)
        if (logoFile) {
          await CampaignRepository.updateCampaignLogo(logoFile, id, rootState.user.token)
        }

        return data.data
      } catch (e) {
        commit(types.SET_ERROR, e)
      } finally {
        commit(types.SET_LOADING, false)
      }
    },
    reset({ commit }) {
      commit(types.RESET)
    },
  },
}
